<script setup>
import GameList from "@/casino/components/GameList.vue"
import { computed, ref, watch } from "vue"
import { fetchGames, fetchProvider } from "../api"
import { useBetStore } from "/store.js"

const props = defineProps({
  slug: {
    type: String,
    required: true,
  },
  filters: {
    type: Object,
    default: () => ({
      search: "",
      providers: [],
      sort: "",
    }),
  },
})
const provider = ref(null)
const games = ref([])
const key = ref(0)

const pagination = ref({
  page: 1,
  rowsPerPage: 100,
})

const store = useBetStore()

const isMobile = computed(() => {
  return store.getScreenWidth < 512
})

// Watch for all filter changes
watch(
  [() => props.filters.search, () => props.filters.providers, () => props.filters.sort],
  async () => {
    games.value = []
    pagination.value.page = 1
    if (provider.value) {
      await loadGames()
      key.value++
    }
  },
  { deep: true },
)

async function loadGames($state = { complete: () => {}, loaded: () => {}, error: () => {} }) {
  try {
    const params = {
      page: pagination.value.page,
      per_page: pagination.value.rowsPerPage,
      provider_id: provider.value.id,
      device: isMobile.value ? "mobile" : "desktop",
    }

    if (props.filters.search) {
      params.search = props.filters.search
    }

    if (props.filters.sort) {
      params.sort = props.filters.sort
    }

    if (props.filters.providers.length) {
      params.providers = props.filters.providers
    }

    const { data } = await fetchGames(params)

    games.value.push(...data.data)

    if (data.data.length < pagination.value.rowsPerPage) {
      $state.complete()
    }
    else {
      $state.loaded()
    }
    pagination.value.page++
  }
  catch {
    $state.error()
  }
}

async function updateData() {
  const { data } = await fetchProvider(props.slug)

  provider.value = data.data
}

updateData()
</script>

<template>
  <article v-if="provider">
    <GameList :key="key" :name="provider.name" :games="games" @load="loadGames" />
  </article>
</template>

<style scoped>
.casino-view {
  width: 100%;
  min-height: 70vh;
}
</style>
